export const AGREEMENT_SIGNATURE_MIN_LENGTH = 3;
export const AGREEMENT_SIGNATURE_MAX_LENGTH = 255;

const ENGLISH_NAME_PATTERN = /^[A-Za-z]+(?: [A-Za-z]+)*$/;

export type AgreementSignatureValidation = {
  isValid: boolean;
  value: string;
  error: string | null;
};

export const normalizeAgreementSignature = (value: string) =>
  value.trim().replace(/\s+/g, ' ');

export const validateAgreementSignature = (
  value: string
): AgreementSignatureValidation => {
  const normalizedValue = normalizeAgreementSignature(value);

  if (!normalizedValue) {
    return {
      isValid: false,
      value: normalizedValue,
      error: 'Please type your full legal name.',
    };
  }

  if (normalizedValue.length < AGREEMENT_SIGNATURE_MIN_LENGTH) {
    return {
      isValid: false,
      value: normalizedValue,
      error: `Signature must be at least ${AGREEMENT_SIGNATURE_MIN_LENGTH} characters.`,
    };
  }

  if (normalizedValue.length > AGREEMENT_SIGNATURE_MAX_LENGTH) {
    return {
      isValid: false,
      value: normalizedValue,
      error: `Signature must be ${AGREEMENT_SIGNATURE_MAX_LENGTH} characters or fewer.`,
    };
  }

  if (!ENGLISH_NAME_PATTERN.test(normalizedValue)) {
    return {
      isValid: false,
      value: normalizedValue,
      error: 'Use English letters and single spaces only.',
    };
  }

  return {
    isValid: true,
    value: normalizedValue,
    error: null,
  };
};
